module.exports = ".botao-selecionar {\n    width: 20%;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/servico-modal/servico-modal.component.css
// module id = ./src/app/modal/servico-modal/servico-modal.component.css
// module chunks = main